import {
  Stack,
  Square,
  Copy,
  SvgCaretLeft,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { RouterLink } from 'src/components/RouterLink/RouterLink';

export function BackToOrderHistory({
  corpId,
}: {
  corpId: string;
}): JSX.Element {
  return (
    <Stack>
      <Square>
        <Copy variant="body" color="interactive">
          <SvgCaretLeft size="16px" />
        </Copy>

        <RouterLink href={`/corporate/enterprise/${corpId}/order-history`}>
          Back to order history
        </RouterLink>
      </Square>
    </Stack>
  );
}
